/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from "#client";
import type { Client, RequestConfig, ResponseErrorConfig } from "#client";
import type { OrgUnitTableRetrievePathOrgUnitId, OrgUnitTableRetrievePathTableId, OrgUnitTableRetrieveStatus200 } from "../types/OrgUnitTableRetrieve.ts";

function getOrgUnitTableRetrieveUrl(org_unit_id: OrgUnitTableRetrievePathOrgUnitId, table_id: OrgUnitTableRetrievePathTableId) {
	const res = { method: "GET", url: `/api/org_unit/${org_unit_id}/table/${table_id}/` as const };

	return res;
}

/**
 * @description Представление текущего заказа стола точки организации.
 * @summary получение текущего заказа стола точки организации
 * {@link /api/org_unit/:org_unit_id/table/:table_id/}
 */
export async function orgUnitTableRetrieve(
	org_unit_id: OrgUnitTableRetrievePathOrgUnitId,
	table_id: OrgUnitTableRetrievePathTableId,
	config: Partial<RequestConfig> & { client?: Client } = {},
) {
	const { client: request = client, ...requestConfig } = config;

	const res = await request<OrgUnitTableRetrieveStatus200, ResponseErrorConfig<Error>, unknown>({
		method: "GET",
		url: getOrgUnitTableRetrieveUrl(org_unit_id, table_id).url.toString(),
		...requestConfig,
	});

	return res.data;
}
